
import Link from '@root/core/src/components/link';
import React from '@root/vendor/react';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';
import { useHistory } from '@root/core/src/components/route';

export default function ContactSupportLink() {
  const { trackClick } = useAnalytics('CONTACT_SUPPORT_LINK');
  const history = useHistory();
  const contactSupportRoute = '/contact-support';

  const handleClick = () => {
    trackClick('CTA');
    history.push(contactSupportRoute);
  };

  return (
    <div>
      Don’t have access to the email address used?&nbsp;
      <Link
        css={styles.cta}
        onClick={handleClick}
      >
        {'Contact support'}
      </Link>
    </div>
  );
}

const styles = StyleSheet.create({
  cta: {
    ...Theme.boldLink(),
    cursor: 'pointer',
    ':hover': {
      opacity: .75,
    },
  },
});

